import React, { Fragment } from 'react'

import type { Props } from './types'

import { ImageMedia } from './ImageMedia'
import { VideoMedia } from './VideoMedia'

export const Media: React.FC<Props> = (props) => {
  const { className, htmlElement = 'div', resource, quality, fetchPriority, sizes, loading } = props

  const isVideo = typeof resource === 'object' && resource?.mimeType?.includes('video')
  const Tag = htmlElement || Fragment

  // Pass optimization props to ImageMedia
  // Default to low fetch priority and lazy loading for non-explicit usages
  const optimizedProps = {
    ...props,
    quality,
    fetchPriority: fetchPriority ?? 'low',
    sizes,
    loading: loading ?? 'lazy',
  }

  return (
    <Tag
      {...(htmlElement !== null
        ? {
            className,
          }
        : {})}
    >
      {isVideo ? <VideoMedia {...optimizedProps} /> : <ImageMedia {...optimizedProps} />}
    </Tag>
  )
}
